module.exports = __webpack_public_path__ + "static/media/hiw16.44b46f0e.svg";